import { FastAPIService } from 'src/app/service/fast-api.service';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-trending',
  templateUrl: './trending.component.html',
  styleUrls: ['./trending.component.scss']
})
export class TrendingComponent implements OnInit{
  keywords: string[] = [];
  loading: boolean = true;

  @Input() width: string = '70%'

  constructor(private route: ActivatedRoute, private router: Router, private service: FastAPIService) {}

  async ngOnInit(): Promise<void> {
    const response = await lastValueFrom(this.service.getTrending());
    const data = response.data;
  //   const data = [
  //     "กรุงเทพน้ำท่วม",
  //     "เกิดอะไรขึ้นที่พระราม 2",
  //     "ข่าวดิจิทัลวอลเล็ทลงทะเบียนยังไง",
  //     "สรุปข่าวพรรคก้าวไกล",
  //     "ผลการแข่งขันของโอลิมปิก 2024"
  // ]

    this.keywords = [];
    let length = 0;
    for(let keyword of data) {
      console.log(keyword)
      if(keyword.keyword.length == 0 || keyword.keyword.length > 100) continue;
      length += 7;
      length += keyword.keyword.length;
      if(length < 120)
        this.keywords.push(keyword.keyword);
      else
        continue;
    }
    this.loading = false;
  }

  onKeywordClick(keyword: string) {
    this.router.navigate(['/home/search', {input: keyword}])
  }
}
